module.exports = { "default": require("core-js/library/fn/array/reverse"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/array/reverse.js
// module id = 359
// module chunks = 29